// Common statuses

export const ALL = 'ALL';

// Student statuses

export const IS_MISSED = 'IS_MISSED';
export const IS_NOT_ON_BOARD = 'IS_NOT_ON_BOARD';
export const IS_ON_BOARD = 'IS_ON_BOARD';

export const MARKER_STATES = {
  ON_BOARDED: 'routes.overview.studentState.onBoarded',
  DELIVERED: 'routes.overview.studentState.delivered',
  ABSENT: 'routes.overview.studentState.absent',
  MISSED: 'routes.overview.studentState.missed',
  SCHEDULED: 'routes.history.details.log.scheduled',
};

// Bus statuses

export const ABORTED = 'ABORTED';
export const NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export const SELECTED = 'SELECTED';
export const ON_TIME = 'ON_TIME';
export const DELAYED = 'DELAYED';
export const COMPLETED = 'COMPLETED';
export const LATE = 'LATE';
export const IN_ALARM = 'IN_ALARM';
export const OFFLINE = 'OFFLINE';
export const DIVERTED = 'DIVERTED';

// Station statuses

export const VISITED = 'VISITED';
export const NOT_VISITED = 'NOT_VISITED';

// Route Direction statuses

export const WAY_BACK = 'WAY_BACK';
export const WAY_TO = 'WAY_TO';
